/**
 * the amount of time we'll wait after an action
 * completes to let the progress bar complete 
 * before transitioning the UI
 */
export const progressBarCompletingPause = 1000;
export const spinnerDelay = 300;